"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const styled_1 = require("../styled");
const TableDiv = styled_components_1.default.div `
  h4 {
    margin-bottom: 0.5em;
  }
  tr {
    border-bottom: 1px solid #e6e8ec;
  }
  tr:last-child {
    border-bottom: 0px;
  }
  td {
    padding-top: 1em;
    padding-bottom: 1em;
  }
  th,
  td {
    white-space: nowrap;
  }
  tbody {
    border-bottom: 0;
  }
`;
const TableCellFunc = styled_components_1.default.td;
const TableCell = TableCellFunc `
  ${props => props.cellType && props.cellType.includes("small") ? "width: 1px;" : ""};
  ${props => props.cellType && props.cellType.includes("none")
    ? `
  &&{
    width: 0px;
    padding: 0;
  }`
    : ""}
  ${props => props.cellType && props.cellType.includes("big") ? "width: 99%;" : ""};
`;
const CenterHeadsFunc = styled_components_1.default.th;
exports.CenterHeads = CenterHeadsFunc `
  ${props => props.cellType && props.cellType.includes("center")
    ? `text-align: center;`
    : ``};
  ${props => props.cellType && props.cellType.includes("small") ? "width: 1px;" : ""};
  ${props => props.cellType && props.cellType.includes("none")
    ? `
  &&{
    width: 0px;
    padding: 0;
  }`
    : ""}
`;
exports.CenterHeads.displayName = "CenterHeads";
class Table extends React.Component {
    render() {
        const { title, head, format, cells, emptyMessage, className } = this.props;
        function formats(i) {
            let formatI = (format || [])[i] || "left";
            return formatI instanceof Array ? formatI : [formatI];
        }
        function formatsToCss(i) {
            return formats(i)
                .map(v => `ptable-${v}`)
                .join(" ");
        }
        return (React.createElement(TableDiv, { className: "ptable " + className },
            title ? React.createElement("h4", null, title) : null,
            cells.length > 0 ? (React.createElement("table", null,
                head ? (React.createElement("thead", null,
                    React.createElement("tr", null, head.map((text, j) => (React.createElement(exports.CenterHeads, { cellType: formats(j), key: `header ${j}`, className: formatsToCss(j) }, text)))))) : null,
                React.createElement("tbody", null, cells.map((row, i) => (React.createElement("tr", { key: `row ${i}` }, row.map((cell, j) => (React.createElement(TableCell, { cellType: formats(j), key: `cell ${i}:${j}`, className: formatsToCss(j) }, cell))))))))) : null,
            cells.length == 0 ? (React.createElement("div", null,
                React.createElement("br", null),
                React.createElement(styled_1.GrayText, { bold: true }, emptyMessage))) : null));
    }
}
exports.Table = Table;
